module.exports = __webpack_public_path__ + "img/12.00c8f486.png";